import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { PhoneContainer } from './PhoneContainer';
import { INewbuildingBuilder } from '../../../types/newbuilding/builder';
import { INewbuildingSeller } from '../../../types/newbuilding/seller';

interface IContactsListCallButtonProps {
  onClick(): void;
  buttonText: string;
  contact: INewbuildingBuilder | INewbuildingSeller;
}

export const ContactsListCallButton = ({ onClick, buttonText, contact }: IContactsListCallButtonProps) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);

  const onButtonClick = React.useCallback(() => {
    onClick();
    setPhoneVisible(true);
  }, [onClick]);

  if (phoneVisible) {
    return <PhoneContainer contact={contact} placeType="Promo" />;
  }

  return (
    <Button data-testid="ContactsListCallButton" theme="fill_primary" size="M" onClick={onButtonClick} tabIndex={-1}>
      {buttonText}
    </Button>
  );
};
